import React from 'react';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Atom Wrapper
 *
 * A wrapper for components
 */
function Wrapper(props) {
  const {
    children,
    className = '',
    spacing = null,
    spacingTop = null,
    spacingBottom = null,
    marginTop = null,
    marginBottom = null,
    centerContent = false,
    bgColor = 'default',
    ...other
  } = props;

  return (
    <div
      className={`${css['section-wrapper']} ${className}`}
      data-spacing={spacing}
      data-spacing-top={spacingTop}
      data-spacing-bottom={spacingBottom}
      data-margin-top={marginTop}
      data-margin-bottom={marginBottom}
      data-bg-color={bgColor}
      data-center-content={centerContent}
      {...other}
    >
      {children}
    </div>
  );
}

export default Wrapper;
